import { SvgProps } from "../../types";

const Notification = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={21}
    fill="none"
    {...props}>
    <path
      fill="#4C5269"
      d="M.333 17.5v-2h2v-7c0-1.383.417-2.612 1.25-3.688C4.417 3.737 5.5 3.034 6.833 2.7V2c0-.417.146-.77.438-1.063A1.447 1.447 0 0 1 8.334.5c.416 0 .77.146 1.062.438.292.291.438.645.438 1.062v.7c1.333.333 2.416 1.037 3.25 2.112.833 1.075 1.25 2.305 1.25 3.688v7h2v2h-16Zm8 3c-.55 0-1.02-.196-1.412-.587a1.926 1.926 0 0 1-.588-1.413h4c0 .55-.195 1.02-.587 1.413a1.926 1.926 0 0 1-1.412.587Zm-4-5h8v-7c0-1.1-.391-2.042-1.175-2.825C10.376 4.892 9.434 4.5 8.335 4.5c-1.1 0-2.042.392-2.825 1.175C4.724 6.458 4.332 7.4 4.332 8.5v7Z"
    />
  </svg>
);
export default Notification;
